module.exports = __webpack_public_path__ + "img/share.d208d949.png";